import { StyleSheet } from 'react-native';
import { themes } from 'src/theme/theme';
export const styles = StyleSheet.create({
  container: {
    paddingTop: 36,
    paddingHorizontal: 16,
    gap: 24,
    flex: 1,
    backgroundColor: themes.light.white[1],
  },
  imagePreview: {
    width: 200,
    height: 200,
    resizeMode: 'contain',
  },
  topContainer: {
    width: '100%',
    flex: 1,
    gap: 24,
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between', // Space between buttons
    gap: 8,
    width: '100%',
    paddingVertical: 12,
    backgroundColor: themes.light.white[1],
  },
  buttonWrapper1: {
    flex: 1, // Allow it to grow
    maxWidth: '33%', // Restrict to 33% width
  },
  buttonWrapper2: {
    flex: 1, // Allow it to grow
    maxWidth: '67%', // Restrict to 67% width
  },
  camera: {
    height: 120,
    width: '100%',
  },
});
